import { RiInstagramLine, RiMailLine, RiYoutubeLine } from "@remixicon/react";
import Flex from "../../atom/flex";

const Footer = () => {
    return (
        <footer className="kt-footer">
            <Flex className="kt-footer-content" justify="center" align="center" gap={10} wrap>
                <a href="https://www.instagram.com/z_y_z_a_" target="__blank"><RiInstagramLine /> @z_y_z_a</a>
                <a href="mailto:mdecesaro@hotmail.com"><RiMailLine /> mdecesaro@hotmail.com</a>
                <a href="https://www.youtube.com/@maysadecesarozyza" target="__blank"><RiYoutubeLine /> @maysadecesarozyza</a>
            </Flex>
            <label>&copy; {new Date().getFullYear()} Katytech. All rights reserved.</label>
        </footer>
    );
};

export default Footer;